// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const DrawerContents = styled.div<{scrollHeight: number}>`
  padding: ${props => `${Math.max(60 - props.scrollHeight, 0)}px`} 20px 20px
    20px;
  width: 100%;
  height: 100%;
`;
DrawerContents.displayName = 'S.DrawerContents';
